/**
 * @module config/taxonomy
 * @description Display labels for categories, parishes and urgency.
 *
 * Brief §6: AFJ edits these from the CMS. In the demo they are config, so
 * no component hard-codes a label list. The category list is the brief's own
 * five (§4.3) even when the sample data has no cause in one of them
 * (Environment): the filter then shows it with a count of 0 rather than
 * hiding it, which is honest about the sample set.
 */
import type { CategoryId, ParishId, UrgencyId } from "../domain/types";

/** Category labels, in the brief's order. */
export const CATEGORY_LABELS: Readonly<Record<CategoryId, string>> = {
    education: "Education",
    healthcare: "Healthcare",
    "economic-development": "Economic Development",
    environment: "Environment",
    community: "Community",
};

/** Parish labels (14 parishes + islandwide). */
export const PARISH_LABELS: Readonly<Record<ParishId, string>> = {
    kingston: "Kingston",
    "st-andrew": "St. Andrew",
    "st-thomas": "St. Thomas",
    portland: "Portland",
    "st-mary": "St. Mary",
    "st-ann": "St. Ann",
    trelawny: "Trelawny",
    "st-james": "St. James",
    hanover: "Hanover",
    westmoreland: "Westmoreland",
    "st-elizabeth": "St. Elizabeth",
    manchester: "Manchester",
    clarendon: "Clarendon",
    "st-catherine": "St. Catherine",
    islandwide: "Islandwide",
};

/** Urgency labels, most to least urgent (also the "Most Urgent" sort order). */
export const URGENCY_LABELS: Readonly<Record<UrgencyId, string>> = {
    urgent: "Urgent",
    "time-sensitive": "Time-sensitive",
    ongoing: "Ongoing",
};

/** Numeric weight for the "Most Urgent" sort (lower = more urgent). */
export const URGENCY_WEIGHT: Readonly<Record<UrgencyId, number>> = {
    urgent: 0,
    "time-sensitive": 1,
    ongoing: 2,
};
